import { render } from "./SMSAction.vue?vue&type=template&id=4d7fbb73&scoped=true"
import script from "./SMSAction.vue?vue&type=script&lang=js"
export * from "./SMSAction.vue?vue&type=script&lang=js"

import "./SMSAction.vue?vue&type=style&index=0&id=4d7fbb73&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d7fbb73"]])

export default __exports__